import React from "react";
import { Button } from "reactstrap";
import { BiArrowBack } from "react-icons/bi";

export default function GoBackComponent({ onGoBack }) {
  return (
    <Button className="ml-5 dani-chat-goBack-btn" size="sm" onClick={onGoBack}>
      <BiArrowBack size={"10px"} /> Go back
    </Button>
  );
}
